import * as React from 'react';
import { Spin } from 'antd';
import Modal from 'antd/lib/modal';
import Tabs from "antd/lib/tabs";
const { TabPane } = Tabs;
import { useCtx } from 'one-ui-provider';
import {
    PatientGlobalSearchCardProps
} from './props';
import {
    EpicPatientSearchTab
} from './epicpetsearchtable';
import {
    EpicProviderSearchTab
} from './epicprosearchtable';
import {
    PatientGlobalSearchModel
} from './model';
import { useDispatch, useSelector } from 'react-redux';

import {
    setAction as globalSearchAction,
    reinitAction as resetPatientSearchAction,
} from 'one-state-patient-global-search';

import {
    reinitAction as resetProviderSearchAction,
} from 'one-state-provider-global-search';

import './style.less';
import { useEffect,useState } from 'react';

export const PatientGlobalSearchCard = <M extends PatientGlobalSearchModel>(
    props: PatientGlobalSearchCardProps<M>
) => {
    const btgpatientdata = useSelector((state: any) => (state.bgtpatient));
    const dispatch = useDispatch();
    const {
        model,
    } = props;
    const { settings } = useCtx();
    const { uisettings: { search,preferred_name }, compatible: { globalsearch_position } } = settings;
    let [isLoading, setIsLoading] = useState(false);

    const handleCancel = (e: any) => {
        dispatch(
            globalSearchAction(false)
        )
        dispatch(resetPatientSearchAction());
        dispatch(resetProviderSearchAction());
    };

    const handleSpin = () =>{
        setIsLoading(true)
    }

    useEffect(() => {
        if (!model?.show) {
            setIsLoading(false)
        }
      }, [model]);        
    
    useEffect(() => {
        if (!model?.spin && model.show) {
            if (btgpatientdata?.error?.status >= 400 || btgpatientdata?.error?.type == "error" || btgpatientdata?.patientbtgdata?.resourceType == "OperationOutcome") {
                setIsLoading(false);
            }
        }
    }, [btgpatientdata])

    let formval = (
        <>
            <div className="new-call">
                <Modal
                    width={1100}
                    visible={model?.show}
                    footer={null}
                    style={{left: globalsearch_position}}
                    closable={true}
                    onCancel={handleCancel}
                    wrapClassName="custom-modal-wrap"
                    destroyOnClose
                    className='globalsearch_modal'
                >   
                    <Spin tip="Loading..."
                          spinning={isLoading}>
                        <Tabs
                            defaultActiveKey="1"
                            style={{ background: "#fff" }}
                            className="tabs"
                            onChange={() => console.debug("tab clicked")}
                        >
                            {
                                (search.patient) && (<TabPane tab="Patient(Subject)" key="1" >
                                    <EpicPatientSearchTab modelvalue={props} loadingspin = {handleSpin} preferred_name={preferred_name}/>
                                </TabPane>)
                            }
                            {
                                (search.provider) && (
                                    <TabPane tab="Provider(Source)" key="2">
                                        <EpicProviderSearchTab modelvalue={props} preferred_name={preferred_name}/>
                                    </TabPane>)
                            }
                        </Tabs>
                    </Spin>
                </Modal>
            </div>
        </>
    );
    return (
        <>
            {formval}
        </>
    );
}